module.exports = __webpack_public_path__ + "static/media/test.3128c736.png";